import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { DataState } from '../model/clergy-bio-app-models';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';


interface Props {
	state: DataState;
	content: JSX.Element;
}

function ClergyBioComponentLoader(props: Props) {

	const { state, content } = props;
	const settings = useSelector<TcsmStates, ClergyBioSettings>(s => s?.epiProps?.clergyBioSettingsState?.epiContent);

	if (state === DataState.LOADING) {
		return <LoadingCircle />;
	}

	if (state === DataState.ERROR) {
		return <WysiwygWithReactLink content={settings?.apiErrorMessage} />;
	}

	if (state === DataState.LOADED) {
		return content;
	}
	return null;
}


export default ClergyBioComponentLoader;